import React, { useEffect, useState } from "react";
import axios from "../../../plugins/axios";
import Toast from "../../../plugins/useToast";
import { useTranslation } from "react-i18next"

import Print from "./Other/Print";
import Demo from "./Other/Demo";

const OtherSettings = ({handleClose,handleSaveParameter}) => {
    const { t } = useTranslation()    
    const [activeTab, setActiveTab] = useState('leftTab1');           

    useEffect(() => {
        console.log("other settings mounted");
    }, []);

    return (
        <div className="w-full h-full relative bg-[#1F1F1F] text-[#DEDEDE]">
            <div className="flex h-full">
                <div className="w-[284px] bg-[#2F2F2F] p-3">
                    <ul className="space-y-2 text-lg">
                        <li onClick={() => setActiveTab('leftTab1')} className={`pl-3 cursor-pointer h-[40px] flex items-center px-2 text-[#CECECE] ${activeTab === 'leftTab1' ? 'bg-[#1F1F1F] text-[#fff] border-l-[2px] border-[#3182F7] rounded-r-md' : ''}`}>
                            {t('setting.print')}</li>                        
                        {/* <li  
                        onClick={() => setActiveTab('leftTab2')}
                        className={`pl-3 cursor-pointer h-[40px] flex items-center px-2 text-[#CECECE] ${activeTab === 'leftTab2' ? 'bg-[#1F1F1F] text-[#fff] border-l-[2px] border-[#3182F7] rounded-r-md' : ''}`}>
                            {t('setting.demoMode')}
                        </li>                         */}
                    </ul>
                </div>

                <div className='w-full py-5 h-full scrollbar pl-[20px]'>                    
                    <div className="flex gap-4 min-h-[376px]" style={{height:'inherit'}}>
                        {activeTab === 'leftTab1' && <Print />}
                        {activeTab === 'leftTab2' && <Demo handleClose={handleClose}/>}
                    </div>
                </div>
            </div>            
        </div>
    );
};

export default OtherSettings;
